import { TypographyColor } from 'melp-design/components';
import { Level } from 'types/Common';
import { BenefitStatus } from './benefits.types';

export const COLOR_BY_BENEFIT_STATUS: Record<BenefitStatus, TypographyColor> = {
  draft: 'textSecondary',
  inactive: 'textSecondary',
  active: 'success',
  expired: 'error',
  expiresSoon: 'warning',
};

export const ALLOCATION_PRIORITY_BY_LEVEL: Record<Level, number> = {
  low: 50,
  medium: 100,
  high: 150,
};
